import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  Header,
  Text,
  FlexColumn,
  FlexRow,
  Icon,
  QuestionCircle,
  COLORS,
} from '@summer/ui-components';

import { Row } from 'components/pages/idr/wizard/shared/styles';
import EmployerNameAndWebsite from 'components/pages/pslf/wizard/steps/submit/EmployerInformation/fields/EmployerNameAndWebsite';
import HrEmail from 'components/pages/pslf/wizard/steps/submit/EmployerInformation/fields/HrEmail';
import HrName from 'components/pages/pslf/wizard/steps/submit/EmployerInformation/fields/HrName';
import EmployerContactHelpModal from 'components/pages/pslf/wizard/steps/submit/EmployerInformation/modals/EmployerContactHelpModal';
import { useFormDrawerFocus } from 'components/shared/FormDrawers';
import { Link } from 'components/shared/typography';
import { trackingEvents } from 'constants/trackingEvents';
import { getUserPartnerKey } from 'redux/selectors/user.selectors';
import { track } from 'utils/track';

const EmployerInfo = ({ formik, show }) => {
  const formRef = React.useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const partnerKey = useSelector(getUserPartnerKey);

  useFormDrawerFocus(formRef, show);

  return (
    <FlexColumn ref={formRef}>
      <EmployerNameAndWebsite formik={formik} />
      <InfoText>
        <Header h3>
          Please provide a contact at your employer who will sign your PSLF
          Certification form
        </Header>
        <Text paragraph>
          This may be someone in Operations or Human Resources, or your manager.
          It&rsquo;s worth confirming the right person as we&rsquo;ll be
          emailing the certification for them to verify and sign.
        </Text>
      </InfoText>
      <HrName formik={formik} />
      <Row>
        <HrEmailContainer>
          <HrEmail formik={formik} />
          {partnerKey === 'nyc' && (
            <>
              <HelpModalTrigger
                onClick={() => {
                  setShowHelpModal(true);
                  track(trackingEvents.PSLF.EMPLOYER_HELP_MODAL_TRIGGERED);
                }}
              >
                <TriggerContent>
                  <QuestionIconStyled
                    SvgComponent={QuestionCircle}
                    fill={COLORS.azure}
                    height={16}
                    width={16}
                  />
                  Not sure who to add?
                </TriggerContent>
              </HelpModalTrigger>
              <EmployerContactHelpModal
                isOpen={showHelpModal}
                setShowHelpModal={setShowHelpModal}
                formik={formik}
              />
            </>
          )}
        </HrEmailContainer>
        <Spacer />
      </Row>
    </FlexColumn>
  );
};

const Spacer = styled.div`
  width: 100%;
`;

const InfoText = styled.div`
  margin: 10px 0 30px 0;
  h3 {
    margin-bottom: 20px;
  }
`;

const HrEmailContainer = styled(FlexColumn)`
  width: 100%;
`;

const HelpModalTrigger = styled(Link)`
  margin-top: -13px;
`;

const TriggerContent = styled(FlexRow)`
  align-items: center;
`;

const QuestionIconStyled = styled(Icon)`
  margin-right: 8px;
`;

export default EmployerInfo;
